import api from '@/API';
import { AxiosRequestConfig } from 'axios';

async function fetchToken(): Promise<string> {
  const response = await api.get('security/csrf-token');
  return response.data.csrfToken;
}

function setToken(token: string): void {
  return window.localStorage.setItem('csrfToken', token);
}

function clearToken(): void {
  return window.localStorage.removeItem('csrfToken');
}

async function getToken(): Promise<string> {
  const storedToken = window.localStorage.getItem('csrfToken');
  if (storedToken) return Promise.resolve(storedToken);
  const token = await fetchToken();
  setToken(token);
  return token;
}

async function attachToken(request: AxiosRequestConfig): Promise<AxiosRequestConfig> {
  if (request.method !== 'post') return request;
  const exclude = [
    'auth/login',
    'auth/login/access-token',
    'one-time-pins',
  ];
  if (request.url && exclude.includes(request.url)) return request;
  const token = await getToken();
  const headers = request.headers || {};
  return {
    ...request,
    headers: {
      ...headers,
      'X-CSRF-Token': token,
    },
  };
}
api.interceptors.request.use(attachToken);

api.interceptors.response.use(undefined, async (error) => {
  if (error.response.data.code === 'CSRF_TOKEN_INVALID') {
    clearToken();
    return api.request(error.config);
  }
  return Promise.reject(error);
});
